import React from 'react'

export const InputName = ({ styles, text }) => {
    return (
        <span className={styles.inputName} >{text}</span>
    )
}
